var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.167 20.833h-8.334V12.5H29.167v8.333h-8.334c-4.583 0-8.333 3.75-8.333 8.334v4.166c0 10.625 8 19.292 18.292 20.584 2.625 6.25 8.25 10.958 15.041 12.333v12.917H29.167V87.5h41.666v-8.333H54.167V66.25c6.791-1.375 12.416-6.083 15.041-12.333C79.5 52.625 87.5 43.958 87.5 33.333v-4.166c0-4.584-3.75-8.334-8.333-8.334zm-58.334 12.5v-4.166h8.334v15.916c-4.834-1.75-8.334-6.333-8.334-11.75zm58.334 0c0 5.417-3.5 10-8.334 11.75V29.167h8.334v4.166z",
    fill: "#61A351",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.f060755dd72f314a2c39bdb24ed39df9.svg";
export { ForwardRef as ReactComponent };